import { useState } from "react";

function SubscriptionModal({ user, onClose, onConfirm }) {
  const [months, setMonths] = useState(0);
  const [years, setYears] = useState(1);
  const [loading, setLoading] = useState(false);

  const totalMonths = (years * 12) + months;

  const handleSubmit = async () => {
    if (totalMonths < 1) return;
    setLoading(true);
    await onConfirm(totalMonths);
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full animate-[scale-in_0.2s_ease-out]">
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white p-6 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-xl font-bold flex items-center gap-2">
                <i className="fas fa-calendar-alt" />
                Set Subscription
              </h3>
              <p className="text-blue-100 text-sm mt-1">
                User: <strong>{user?.userName}</strong> (ID: {user?.userId})
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-white/80 hover:text-white transition"
            >
              <i className="fas fa-times text-xl" />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="p-6 space-y-6">
          <div className="grid grid-cols-2 gap-4">
            {/* Years Select */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                Years
              </label>
              <select
                value={years}
                onChange={(e) => setYears(parseInt(e.target.value))}
                className="w-full px-3 py-3 rounded-lg border-2 border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:border-blue-500 transition"
              >
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((y) => (
                  <option key={y} value={y}>{y} {y === 1 ? "Year" : "Years"}</option>
                ))}
              </select>
            </div>

            {/* Months Select */}
            <div className="space-y-2">
              <label className="text-sm font-semibold text-gray-700 dark:text-gray-300">
                Extra Months
              </label>
              <select
                value={months}
                onChange={(e) => setMonths(parseInt(e.target.value))}
                className="w-full px-3 py-3 rounded-lg border-2 border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:outline-none focus:border-blue-500 transition"
              >
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((m) => (
                  <option key={m} value={m}>{m} {m === 1 ? "Month" : "Months"}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Total Summary */}
          <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 text-center">
            <p className="text-sm text-blue-700 dark:text-blue-300 mb-1">Total Subscription Period</p>
            <p className="text-2xl font-bold text-blue-800 dark:text-blue-200">
              {totalMonths} {totalMonths === 1 ? "Month" : "Months"}
            </p>
            {totalMonths > 0 && (
              <p className="text-xs text-blue-600 dark:text-blue-400 mt-1">
                {years > 0 ? `${years} ${years === 1 ? "year" : "years"}` : ""}
                {years > 0 && months > 0 ? " + " : ""}
                {months > 0 ? `${months} ${months === 1 ? "month" : "months"}` : ""}
              </p>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-6 pt-0">
          <button
            onClick={onClose}
            className="flex-1 py-3 bg-gray-200 dark:bg-slate-700 hover:bg-gray-300 dark:hover:bg-slate-600 text-gray-700 dark:text-gray-300 font-semibold rounded-lg transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading || totalMonths < 1}
            className="flex-1 py-3 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold rounded-lg flex items-center justify-center gap-2 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin" />
                Setting...
              </>
            ) : (
              <>
                <i className="fas fa-check" />
                Set Subscription
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionModal;
